/* eslint-disable no-dupe-keys */
const styleBase = {
  container: (provided) => ({ ...provided }),
  menu: (provided) => ({
    ...provided,
    overflow: 'hidden',
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: '0px',
    paddingBottom: '0px',
    // overflow: 'hidden',
  }),
  control: (provided) => ({
    ...provided,
    boxShadow: '0 0 0 1px transparent',
    borderColor: '#DBDBDB',
    borderWidth: '1px',
    backgroundColor: '#FFFFFF',
    minHeight: '45px',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontFamily: 'Museo',
    fontSize: '16px',
    color: '#636363',
  }),
  valueContainer: (provided) => ({
    ...provided,
  }),
  singleValue: (provided) => ({ ...provided, fontFamily: 'Museo', fontSize: '16px' }),
  multiValue: (provided) => ({ ...provided, fontFamily: 'Museo', fontSize: '16px' }),
  multiValueLabel: (provided) => ({ ...provided }),
  multiValueRemove: (provided) => ({
    ...provided,
    backgroundColor: 'rgb(230, 230, 230)',
    '&:hover': {
      backgroundColor: 'rgb(230, 230, 230)',
    },
  }),
  input: (provided) => ({
    ...provided,
    '&:focus': {
      boxShadow: '',
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#000000',
    padding: '8px 4px',
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '16px',
    backgroundColor: state.isSelected ? '#edebeb' : '',
    color: '#000000',
    cursor: 'pointer',
    fontFamily: 'Museo',
    '&:hover': {
      backgroundColor: state.isSelected ? '#edebeb' : '#dbd7d7',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '8px 0 ',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '42px',
  }),
};

const styleBold = {
  container: (provided) => ({ ...provided }),
  menu: (provided) => ({
    ...provided,
    overflow: 'hidden',
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: '0px',
    paddingBottom: '0px',
    // overflow: 'hidden',
  }),
  control: (provided) => ({
    ...provided,
    boxShadow: '0 0 0 1px transparent',
    borderColor: '#000000',
    borderWidth: '1px',
    backgroundColor: 'transparent',
    minHeight: '45px',
    borderRadius: '3px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontFamily: 'Museo-Bold',
    textTransform: 'uppercase',
    fontSize: '16px',
    color: '#636363',
  }),
  valueContainer: (provided) => ({
    ...provided,
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '16px',
    fontFamily: 'Museo-Bold',
    textTransform: 'uppercase',
  }),
  multiValue: (provided) => ({
    ...provided,
    fontSize: '16px',
    fontFamily: 'Museo-Bold',
    textTransform: 'uppercase',
  }),
  multiValueLabel: (provided) => ({ ...provided }),
  multiValueRemove: (provided) => ({ ...provided }),
  input: (provided) => ({
    ...provided,
    fontFamily: 'Museo-Bold',
    textTransform: 'uppercase',
    '&:focus': {
      boxShadow: '',
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#000000',
    padding: '8px 4px',
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '16px',
    backgroundColor: state.isSelected ? '#edebeb' : '',
    color: '#000000',
    cursor: 'pointer',
    fontFamily: 'Museo-Bold',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: state.isSelected ? '#edebeb' : '#dbd7d7',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '8px 0 ',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '37px',
  }),
};

export {
  styleBase,
  styleBold,
};
